<template>
  <app-section-wrap :modifier="'header'">
    <nav column="12">
      <div class="flex-wrapper">
        <div class="logo">
          <router-link :to="loggedIn ? { name: 'dashboard' } : '/'">
            <img src="../../assets/images/eyemed-logo.svg" alt="EyeMed Logo">
          </router-link>
        </div>
        <app-nav-login v-if="!loggedIn"></app-nav-login>
        <app-universal-search v-else></app-universal-search>
      </div>
    </nav>
  </app-section-wrap>
</template>
<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AppNavLogin from '@organisms/NavLogin.vue'
  import AppUniversalSearch from '@organisms/UniversalSearch.vue'
  export default {
    props: {
      loggedIn: {
        type: Boolean,
        default: false
      }
    },
    components: {
      AppSectionWrap,
      AppNavLogin,
      AppUniversalSearch
    }
  }
</script>
